import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "32_checkbox.svg",
  "use": "32_checkbox.svg-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"32_checkbox.svg\"><rect width=\"32\" height=\"32\" style=\"fill:none\" /><rect x=\"3.55\" y=\"3.55\" width=\"24.9\" height=\"24.9\" style=\"fill:#fff;stroke:#383838;stroke-miterlimit:1;stroke-width:1.100000023841858px\" /><polyline points=\"7.54 14.94 13.98 21.47 24.83 10.62\" style=\"fill:none;stroke:#228bcb;stroke-miterlimit:1;stroke-width:1.399999976158142px\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol